// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__2wQjh","OrderButton":"BuildControls_OrderButton__1i-sc","enable":"BuildControls_enable__gp7-X"};